<template>

<div>
	
	<select class="form-control" v-on:change="selectChange" v-model="cselect" style="width:60%;">
		<option v-for="option in extraData" v-bind:value="option.value">{{ option.text }}</option>
	</select>

</div>

</template>


<script>
    export default {
        props: {
	        type: {},
	        currentData: {},
	        extraData: {}
	    },
	    data: function() {

            return {

                cselect: 1
               
            }

        },

        created() {

        	this.setcselect()

        },

	    methods: {
	 
	    	selectChange: function() {

	    		console.log(this.cselect);

	    		bus.$emit('select-changed', this.type, this.cselect)


	    	},

	    	setcselect() {

	    		if(this.currentData.value) {

	    			this.cselect = this.currentData.value;

	    		} else {
	    			this.cselect = null;
	    		}

	    	}

	    },
	    
	    watch: {

	    	currentData: function() {

	    		this.setcselect()
	    		
	    	}

	    }

    }
</script>